<template>
  <div class="invoiceManagentPage">
    <Table border :columns="columns" :data="tableData">
      <!-- 申请中 -->
      <template slot-scope="{ row, index }" slot="action">
        <!-- 因为已申请的状态是不可操作   代表验证通过 -->
        <div v-if="row.invoice_status=='2'||row.invoice_status=='4'">
          <Button type="primary" size="small" style="margin-right: 15px" disabled>修改</Button>
          <Button type="primary" size="small" disabled>取消申请</Button>
          <Button
            v-if="row.invoice_status=='2'"
            type="primary"
            size="small"
            @click="lookOrder(row)"
          >获取快递单号</Button>
        </div>
        <div v-else>
          <Button type="primary" size="small" style="margin-right: 15px" @click="edit(row,index)">修改</Button>
          <Button type="primary" size="small" @click="cancel(row,index)">取消申请</Button>
        </div>
      </template>
    </Table>

    <!-- 获取快递单号 -->
    <Modal v-model="modal" title="  " cancel-text>
      <template>
        <p style="margin-bottom:20px;font-size:16px">
          快递
          <span style="margin-left:15px">{{express}}</span>
        </p>
        <p style="margin-bottom:10px;font-size:16px">
          单号
          <span style="margin-left:15px">{{orderNum}}</span>
        </p>
      </template>
    </Modal>

    <!-- 确认取消 -->
    <Modal v-model="modal1" title="请确认" @on-ok="ok" @on-cancel="modal1=false">
      <p style="font-size:18px">是否取消申请</p>
    </Modal>
  </div>
</template>

<script>
import doPost from "@/pages/Helper/XHR.js";
export default {
  data() {
    return {
      columns: [
        {
          title: "金额",
          key: "invoice_money",
          align: "center",
          minWidth: 80,
        },
        {
          title: "类型",
          key: "invoice_type",
          align: "center",
          minWidth: 100,
        },
        {
          title: "抬头",
          key: "invoice_rise",
          align: "center",
          minWidth: 180,
        },
        {
          title: "地址",
          key: "mail_address",
          align: "center",
          minWidth: 180,
        },
        {
          title: "申请时间",
          key: "date",
          align: "center",
          minWidth: 180,
        },
        {
          title: "状态",
          key: "invoice_status",
          align: "center",
          maxWidth: 180,
          minWidth: 80,
          render:(h,params) => {
            let status = params.row.invoice_status; //1申请中 2已申请 3信息有误 4已取消
            if (status=='1'){ return h('div','申请中') };
            if (status=='2'){ return h('div','已申请') };
            if (status=='3'){ return h('div',{style:{color:'red'}},'信息有误') };
            if (status=='4'){ return h('div','已取消') };
          }         
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 120,
        },
      ],
      tableData: [],
      modal: false,
      modal1: false,
      express: "",
      orderNum: "",
    };
  },
  created() {
    this.freshData();
  },
  methods: {
    edit(row, i) {
      console.log(row, i);
      //修改的时候要保存金额，以及对应的数据。然后传到下一个组件
      localStorage.setItem("invoice_money", this.tableData[i].invoice_money);
      localStorage.setItem("orderInfo", JSON.stringify(row));
      this.$emit("gonvoicemangent", "2");
    },
    cancel(row, i) {
      localStorage.setItem("invoice_id", row.id);
      this.modal1 = true;
      //取消申请
      // doPost(
      //   {action:'invoice_Cancel',session_str:localStorage.getItem('session_str'),invoice_id:row.id},
      //   (res)=>{
      //       if(!res.status){
      //         //提醒用户
      //         this.$Message.success(res.detail);
      //         this.freshData();
      //       }else{
      //         this.$Message.error(res.detail);
      //       }
      //   }
      // )
    },

    //查看快递单号--后台字段
    lookOrder(row) {
      this.orderNum = row.numbers;
      this.express = row.express;
      this.modal = true;
      console.log(row.invoice_type);
    },

    //数据更新
    freshData() {
      doPost(
        {
          action: "invoice_Manage",
          session_str: localStorage.getItem("session_str"),//这里的session_str是登录的时候存储的
        },
        (res) => {
          if (!res.status) {
            this.tableData = res.list;
            // this.tableData.forEach((item, index) => {
            //   switch (item["invoice_status"]) {
            //     case "1":
            //       this.tableData[index].invoice_status = "申请中";
            //       break;
            //     case "2":
            //       this.tableData[index].invoice_status = "已申请";
            //       break;
            //     case "3":
            //       this.tableData[index].invoice_status = "信息有误";
            //       break;
            //     case "4":
            //       this.tableData[index].invoice_status = "已取消";
            //       break;
            //     default:
            //   }
            // });
          } else {
            if (res.detail == "权限验证失败") {
              this.$Message.warning("登录已过期，即将重新登陆");
              setTimeout(()=>{
                this.$emit('loginout');
              }, 1500);
            }
          }
        }
      );
    },
    ok() {
      //取消申请
      doPost(
        {
          action: "invoice_Cancel",
          session_str: localStorage.getItem("session_str"),
          invoice_id: localStorage.getItem("invoice_id"),
        },
        (res) => {
          if (!res.status) {

} else {
            this.$Message.error(res.detail);
          }
        }
      );
    },
  },
};
</script>

<style lang='stylus' scoped>
.invoiceManagentPage {
  width: 100%;
  height: 400px;
  overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// src/pages/Personal/components/InvoiceManagent.vue